<template class="full-height">
  <div class="socket-app-container" style="position: relative; height: 100%; padding: 10px">
    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item label="User查詢">
          <el-input v-model="listQuery.account" placeholder="輸入User帳號" />
        </el-form-item>

        <el-form-item label="日期">
          <el-date-picker
            v-model="listQuery.dateRange"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="日期" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.buildDate }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="團ID" width="50">
          <template slot-scope="scope">
            <span>{{ scope.row.travelID }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="團號" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.tourGroupName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="團名" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.travelName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="帳號" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.userAccount }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="姓名" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.userName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="msgType" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.msgType }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="C" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.sdp_c }}</span>
          </template>
        </el-table-column>

        <el-table-column align="left" label="M" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.sdp_m }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'

import { getSdpHistory } from '@/api/system'
var defaultForm = {
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'SocketInfo',
  components: {
    Pagination,
  },
  data() {
    return {
      currentLogContent: null,
      logContentDialogVisible: false,
      currentLogs: [],
      logDialogVisible: false,
      funcName: '旅遊團Socket狀態',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-buildDate',
      },
      total: 0,
      list: [],
    }
  },
  async created() {
    this.form = defaultForm
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    getLogs(row) {
      this.currentLogs = row.logs
      this.logDialogVisible = true
    },
    showContent(c) {
      this.currentLogContent = c.msg
      this.logContentDialogVisible = true
    },
    addData() {
      this.dialogVisible = true
    },
    editData(row) {
      this.form = row
      console.log(this.form)
      this.dialogVisible = true
    },
    async saveData() {
      let vm = this
    },
    async getList() {
      this.listLoading = true
      console.log(this.listQuery)
      let resp = await getSdpHistory(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.total
      this.listLoading = false

      console.log(this.list)
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
